import React, { useState, useEffect, useRef } from "react";
import Check from "../../SVG/Check";
import CustomCheckbox from "./style";
import { Radio } from "@mui/material";
import "../../../Style/Theme/index.css";

export default function Index({
  value,
  label,
  checked,
  defaultChecked,
  disabled,
}) {
  const [clicked, setClicked] = useState(false);
  const handleClick = () => {
    setClicked(true);
  };
  const ref = useRef(null);
  useEffect(() => {
    const onClickOutside = () => {
      setClicked(false);
    };
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        onClickOutside && onClickOutside();
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);
  return (
    <CustomCheckbox
      ref={ref}
      className={clicked && "customCheckBox_Th"}
      control={
        <Radio
          value={value}
          checked={checked}
          defaultChecked={defaultChecked}
          checkedIcon={<Check />}
          icon={<></>}
          onClick={handleClick}
          disabled={disabled && disabled}
        />
      }
      label={label}
      // sx={
      //   clicked &&
      //   {
      //     // backgroundColor: "rgba(246, 248, 253, 1)",
      //   }
      // }
    />
  );
}
